import styled, { css } from 'styled-components';

// Types
import { variant } from './types';

// Components
import { Typography } from '../../../display/Typography';

// Styles utils

interface ContainerProps {
  variant: variant;
}
export const Text = styled(Typography)`
  white-space: nowrap;
`;

export const Container = styled.button<ContainerProps>`
  border: 0;
  border-radius: ${({ theme }) => theme.borderRadius.md};
  height: ${({ theme }) => theme.sizes.buttonHeight};
  padding: 1rem 2rem;
  transition-duration: 0ms;
  display: flex;
  align-items: center;
  ${({ variant, theme }) =>
    ({
      primary: css`
        background-color: ${theme.colors.garnet};
      `,
      secondary: css`
        background-color: transparent;
        outline: 0.1rem solid ${theme.colors.garnet};
      `,
      tertiary: css`
        background-color: transparent;
        outline: 0.1rem solid ${theme.colors.blueActuation};
      `,
      quaternary: css`
        background-color: transparent;
        outline: 0.1rem solid ${theme.colors.blueOT};
      `,
    })[variant]}
  &:hover:not(:disabled):not(:focus-visible) {
    ${({ variant, theme }) =>
    ({
      primary: css`
          background-color: ${theme.colors.darkBurgundyRed};
        `,
      /* El hover NO debe cambiar la geometría del botón (feedback usuario
         2026-07-14: en el popover del timer el secundario encogía al pasar
         el ratón). Antes estos bloques redefinían `max-width: 19.641rem` y
         un padding distinto SOLO en hover → salto de tamaño. Ahora el hover
         solo cambia color/outline/peso de texto. */
      secondary: css`
          ${Text} {
            color: ${theme.colors.veryDarkBurgundyRed};
            font-weight: ${theme.fontWeight.semiBold};
          }
          outline: 0.1rem solid ${theme.colors.veryDarkBurgundyRed};
        `,
      tertiary: css`
          ${Text} {
            color: ${theme.colors.blueOT};
            font-weight: ${theme.fontWeight.semiBold};
          }
          outline: 0.1rem solid ${theme.colors.blueOT};
        `,
      quaternary: css`
          ${Text} {
            color: ${theme.colors.white};
            font-weight: ${theme.fontWeight.semiBold};
          }
          background-color: ${theme.colors.blueOT};
          outline: 0.1rem solid ${theme.colors.blueOT};
        `,
    })[variant]}
  }
  &:active:not(:disabled):not(:focus-visible) {
    ${({ variant, theme }) =>
    ({
      primary: css`
          background-color: ${theme.colors.darkBurgundyRed};
        `,
      secondary: css`
          ${Text} {
            color: ${theme.colors.white};
          }
          background-color: ${theme.colors.darkBurgundyRed};
          outline: none;
        `,
      tertiary: css`
          ${Text} {
            color: ${theme.colors.white};
          }
          background-color: ${theme.colors.darkBurgundyRed};
          outline: none;
        `,
      quaternary: css`
          ${Text} {
            color: ${theme.colors.white};
          }
          background-color: ${theme.colors.blueOT};
          filter: brightness(0.85);
          outline: none;
        `,
    })[variant]}
    border: none;
  }
  &:focus-visible {
    ${({ variant, theme }) =>
    ({
      primary: css`
          outline: 0.3rem solid ${theme.colors.deepRedWine};
        `,
      secondary: css`
          outline: 0.3rem solid ${theme.colors.darkGrey};
        `,
      tertiary: css`
          outline: 0.3rem solid ${theme.colors.blueOT};
        `,
      quaternary: css`
          outline: 0.3rem solid ${theme.colors.blueOT};
        `,
    })[variant]}
  }
  &:disabled {
    cursor: auto;
    ${({ variant, theme }) =>
    ({
      primary: css`
          background-color: ${theme.colors
          .backgroundLila}; /* CAMBIO: Usar color lila ROIS */
        `,
      secondary: css`
          outline-color: ${theme.colors
          .backgroundLila}; /* CAMBIO: Usar color lila ROIS */
        `,
      tertiary: css`
          outline-color: ${theme.colors
          .backgroundLila}; /* CAMBIO: Usar color lila ROIS */
        `,
      quaternary: css`
          outline-color: ${theme.colors
          .backgroundLila}; /* CAMBIO: Usar color lila ROIS */
        `,
    })[variant]};
  }
  @media (max-width: ${({ theme }) =>
    theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    padding-left: 1.2rem;
    padding-right: 1.2rem;
  }
`;
